var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13603_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2075 7.31243C14.875 10.0474 12.8375 11.1199 11.63 9.99743C9.4025 7.93243 14.5225 5.61243 10.45 3.17243C11.8425 6.10243 8.465 6.56493 8.4525 4.79243C8.4375 2.90743 7.6425 1.68743 5.4 1.36743C6.9325 3.53493 5.6825 4.81993 4.2075 7.50993C3.475 8.84743 3.9475 10.7049 3.9475 10.7049C3.9475 10.7049 3.0325 8.41493 0.75 8.48493C2.1025 9.91993 1.3275 10.5149 1.795 12.3549C2.33 14.4699 4.83 15.9999 8.1175 15.9999C14.3175 15.9999 16.86 10.1249 14.2075 7.31243Z",
    fill: "url(#paint0_linear_13603_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6225 11.0801C12.6425 12.3751 10.22 12.1951 10.22 12.1951C11.715 9.71259 9.8375 9.03259 10.4175 6.64509C8.7425 7.53259 8.8875 8.88759 8.0925 9.48009C7.045 10.2576 6.38 7.68009 7.1175 4.96509C3.3075 8.70259 5.93 12.9401 5.93 12.9401C5.93 12.9401 4.175 12.8351 3.26 11.3876C3.0325 12.3726 3.395 15.7551 8.3525 15.7551C12.6525 15.7526 13.895 12.3576 13.6225 11.0801Z",
    fill: "url(#paint1_linear_13603_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2025 15.5175C5 15.5175 4.5625 14.235 4.5625 13.24C5.5025 14.92 7.5225 14.155 7.0225 13.12C6.5825 12.2125 7.1475 10.615 8.8925 10.54C7.52 12.4725 9.45 14.085 11.1325 13.1825C11.3125 14.27 10.1375 15.5175 8.2025 15.5175Z",
    fill: "url(#paint2_linear_13603_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25999 4.27759C2.63249 5.17759 4.81999 6.10509 2.78999 7.60759C2.67249 6.48759 1.10749 5.63009 2.25999 4.27759Z",
    fill: "url(#paint3_linear_13603_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.495 5.78247C13.1225 6.54747 11.1725 7.24997 12.85 8.64747C13.0125 7.68247 14.42 7.00997 13.495 5.78247Z",
    fill: "url(#paint4_linear_13603_1562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49746 0C9.48996 0.735 8.29496 1.92 10.02 2.5125C9.80496 1.6825 10.6075 0.695 9.49746 0Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13603_1562",
    x1: 8,
    y1: 15.9999,
    x2: 8,
    y2: 1.36728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1016,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13603_1562",
    x1: 8.43545,
    y1: 15.7519,
    x2: 8.43545,
    y2: 4.96446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1629,
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FF9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6723,
    stopColor: "#FF7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8695,
    stopColor: "#FF6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13603_1562",
    x1: 7.85443,
    y1: 15.5174,
    x2: 7.85443,
    y2: 10.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#FFECA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#FFDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7277,
    stopColor: "#FFD12D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9034,
    stopColor: "#FFCB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13603_1562",
    x1: 2.74089,
    y1: 7.60676,
    x2: 2.74089,
    y2: 4.27664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1807,
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#FF8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    stopColor: "#FF5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    stopColor: "#FF3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#FF1600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13603_1562",
    x1: 12.992,
    y1: 8.64792,
    x2: 12.992,
    y2: 5.78227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1807,
    stopColor: "#FF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#FF8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    stopColor: "#FF5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7914,
    stopColor: "#FF3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9331,
    stopColor: "#FF1600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13603_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel3);
export default __webpack_public_path__ + "static/media/label-3.dd43133f729b14cddbe4f0c8209317a5.svg";
export { ForwardRef as ReactComponent };